module.exports = __webpack_public_path__ + "static/img/img-21.deed718.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-21.jpg
// module id = IAfA
// module chunks = 1